import React from "react";
import { useDispatch } from "react-redux";
import { requestedServiceSelector } from "action/LanguageAct";
import { history } from "service/helpers";
import { NormalButton } from "component/common/NormalButton";
import "./style.scss";
import { getI18n, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const FraudBanner = ({ bannerData, translation = false, executeScroll }) => {
  const { i18n, t } = useTranslation();
  const currentLanguage = getI18n().language;
  const dispatch = useDispatch();
  function fraudServiceNavigator(url, serviceRequested) {
    history.push({
      pathname: `/individuals/customer-service/pregnancy-follow-up-program#request-service`,
    });
    dispatch(requestedServiceSelector(serviceRequested));
  }

  const trackEvent = (tabClicked) => {
    window.lmSMTObj.track(tabClicked);
  }
  return (
    <div className="row SupportRequestContainer p-3">
      {bannerData.map((item, index) => {
        return (
          <React.Fragment>
            <div className={`${item.bannerLayout} col-lg-12 col-12`} key={index}>
              <p className="fw-800 fraudTitle">{translation ? t(item.fraudTitle) : item.fraudTitle}</p>
              <p>{item.fraudSubTitle}</p>
              <p className="fraudParaOne fs-18 fw-400">
                {translation ? t(item.fraudPara) : item.fraudPara}
              </p>
              <ul className="p-0 pl-4">
                {item?.fraudList?.map((items, index) => {
                  return (
                    <li key={index} className="fraudParaTwo fs-18 fw-400">
                      {translation ? t(items.para) : items.para}
                    </li>
                  );
                })}
              </ul>
              <div className="d-flex flex-row butt-link">
                <div className="ban-butt">
                  <Link to="/login" className="global_link" onClick={() => {trackEvent(translation ? t(item.btnLabel) : item.btnLabel+"Clicked")}}>
                    <NormalButton
                      label={translation ? t(item.btnLabel) : item.btnLabel}
                      className="reportFraudBtn"
                    />
                  </Link>
                </div>
                <div className="px-lg-3 learnButt" onClick={(e) => {(window.scrollTo({ top: 525 }));trackEvent(t("Learn more")+"Clicked")}}>
                  <NormalButton
                    label={t("Learn more")}
                    className="learnMoreBtn"

                  />
                </div>
              </div>
              <img
                src={item.bannerPic}
                className={`${item.fraudBannerImgClass} img-fluid ${currentLanguage === "ar" ? "rtl" : ""}`}
                alt="banner"
              />
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};
